/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Stringemptyaspect7Inputs */



/**

* @param {_Filter_Class_Stringemptyaspect7Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_stringemptyaspect7 = /** @type {((inputs?: _Filter_Class_Stringemptyaspect7Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Stringemptyaspect7Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("leer")
});
export { _filter_class_stringemptyaspect7 as "_filter_class_StringEMPTYAspect" }